import React, { useEffect, useState } from 'react'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import Typography from '@mui/material/Typography'
import InputField from '../../../../../FormControl/input/InputField'
import Dialog from '../../../../../dialog/Dialog'
import useTerms from '../../../../../../hooks/setting/useTerms'
import { Alert } from '@mui/material'
import InputDateUTC from '../../../../../FormControl/input/InputDateUTC'
import FormatDate from '../../../../../date/FormatDate'

const TermDialog = ({ show, onClose, type, data = {} }) => {
  const types = ['create', 'edit', 'preview', 'delete', 'sync']
  const { 
    errors: errorsData,
    createTerm,
    updateTerm,
    deleteTerm,
    syncTerms
  } = useTerms()
  const [form, setInputForm] = useState({})
  const [errors, setInputErrors] = useState(errorsData)
  const [loading, toggleLoading] = useState(false)

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
  }

  const onSave = async (e) => {
    if (!types.includes(type))  {
      setInputErrors({ message: 'Invalid type' })
      return
    }
    e.preventDefault()
    toggleLoading(true)
    try {
      let result = { error: false } 
      if (type === 'create') {
        result = await createTerm(form)
      }
      if (type === 'edit') {
        result = await updateTerm(form._id, form)
      }
      if (type === 'delete') {
        result = await deleteTerm(form._id)
      }
      if (type === 'sync') {
        result = await syncTerms()
      }
      if (result.error) {
        setInputErrors(result)
      } else {
        onClose()
      }
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    setInputErrors(errorsData)
  }, [errorsData])

  useEffect(() => {
    setInputForm(data || {})
  }, [data])

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      { ['create', 'edit', 'delete', 'sync'].includes(type) &&
        <ButtonStartIcon
        onClick={onSave}
        color='primary'
        variant='contained'
        disabled={loading}
        loading={loading}
        startIcon={["fal","check"]}
      >
        { type === 'delete' ? 'Confirm' : 'Save'}
      </ButtonStartIcon>
      }
    </>
  );
  
  return (
    <Dialog
      id={`${type}-term`}
      show={show} 
      title={`${type} term`}
      onClose={onClose}
      actions={Actions}
    >
      { ['delete'].includes(type)
        ? <Typography component={'div'}>Are you sure you want to {type} the term: <b>{form.name}</b>?</Typography>
        :  ['sync'].includes(type)
        ? <Typography component={'div'}>Are you sure you want to sync the terms?</Typography>
        : types.includes(type) && <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-3 items-start gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Name
            </Typography>
            <div className='col-span-2'>
              { type === 'preview'
                ? <Typography>
                    {form.name}
                  </Typography>
                :  <InputField
                  id='name'
                  name='name'
                  value={form.name}
                  error={errors?.name}
                  helperText={errors?.name}
                  onChange={(e) => onChange('name', e.target.value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Short Name
            </Typography>
            <div className='col-span-2'>
              { type === 'preview'
                ? <Typography>
                    {form.shortName}
                  </Typography>
                :  <InputField
                  id='shortName'
                  name='shortName'
                  value={form.shortName}
                  error={errors?.shortName}
                  helperText={errors?.shortName}
                  onChange={(e) => onChange('shortName', e.target.value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Start date
            </Typography>
            <div className='col-span-2'>
              { type === 'preview'
                ? <Typography>
                    <FormatDate date={form.startDate} />
                  </Typography>
                :  <InputDateUTC
                  id='startDate'
                  name='startDate'
                  value={form.startDate}
                  error={errors?.startDate}
                  helperText={errors?.startDate}
                  onChange={(value) => onChange('startDate', value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              End date
            </Typography>
            <div className='col-span-2'>
              { type === 'preview'
                ? <Typography>
                    <FormatDate date={form.endDate} />
                  </Typography>
                :  <InputDateUTC
                  id='endDate'
                  name='endDate'
                  value={form.endDate}
                  error={errors?.endDate}
                  helperText={errors?.endDate}
                  isStartOfTheDay={false}
                  onChange={(value) => onChange('endDate', value)}
                  fullWidth
                />
              }
            </div>
          </div>
        </div>
      }
      { errors && errors.message && 
        <Alert 
          severity="error"
          onClose={() => setInputErrors({ message: null })}
        >
          {errors.message}
        </Alert> 
      }
    </Dialog>
  )
}

export default TermDialog